import {Typography} from '@mui/material';
import React from 'react';
import {translations} from 'presentation/translations-new';
import {StyledContainer, StyledContainerIcon, StyledIcon} from './styles';

const {myHospitalizationAlert} = translations['pt-br'].publicFlow;

export const CompanionAlert = () => (
	<StyledContainer>
		<StyledContainerIcon>
			<StyledIcon name="help-outline-filled" />
		</StyledContainerIcon>
		<Typography variant="body2">{myHospitalizationAlert}</Typography>
	</StyledContainer>
);
